import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a20bb3ce&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a20bb3ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20bb3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a20bb3ce')) {
      api.createRecord('a20bb3ce', component.options)
    } else {
      api.reload('a20bb3ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a20bb3ce&scoped=true&lang=pug", function () {
      api.rerender('a20bb3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vipMgm/giftContentOne/index.vue"
export default component.exports